<template>
    <div class="toast hide" :class="status" role="alert" aria-live="assertive" aria-atomic="true" data-delay="2000">
        <div class="toast-body">
            <i class="icon-filledcheckcircle"></i>
            <span>
                {{ message }}
            </span>
        </div>
    </div>
</template>

<script>
export default {
    props: {},

    data() {
        return {
            status: "success",
            message: "",
        };
    },

    methods: {
        activate(status, message) {
            this.status = status;
            this.message = message;

            $(this.$el).toast("show");

            return new Promise((resolve) => {
                this.resolvePromise = resolve;
            });
        },
    },
};
</script>
